import React, {useState} from 'react';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import {IconButton} from '@material-ui/core';
import PageLoader from '../../../../components/PageLoader';
import MouseOverPopover from '../../../../components/MousePopOver/MousePopOver';
import Done from '@material-ui/icons/Done';
import Clear from '@material-ui/icons/Clear';
import {useSelector} from 'react-redux';

const FieldTable = ({
  selectedRows,
  setSelectedRows,
  values,
  handleChange,
  touched,
  errors,
  inputFieldValues,
  setInputFieldValues,
  setFieldValue,
  setDeleteEnableId,
  recordFormatCode,
  deleteEnableId,
}) => {
  const [loader, setLoader] = useState(false);
  const {dropDownData} = useSelector(({addRecordFormat}) => addRecordFormat);

  const reorderItems = (startIndex, endIndex) => {
    const arr = [...selectedRows];
    const [removed] = arr.splice(startIndex, 1);
    arr.splice(endIndex, 0, removed);
    setSelectedRows(arr);
  };

  const onDragEnd = (result) => {
    const {source, destination} = result;
    if (!destination) {
      return;
    }
    reorderItems(source.index, destination.index);
  };

  const handleDelete = (rowData, key) => {
    const arr = [...selectedRows];

    arr.forEach((ele) => {
      delete ele.deleteState;
    });
    arr.splice(key, 1, {...arr[key], deleteState: true});

    const newDeletedIds = [...deleteEnableId];
    if (rowData?.memberId) {
      newDeletedIds.push(rowData?.memberId);
    }
    setSelectedRows(arr);
    setDeleteEnableId(newDeletedIds);
  };

  const handleConfirmDelete = (rowData, key) => {
    setLoader(true);
    setTimeout(() => {
      const arr = [...selectedRows].filter((r) => r.fieldCode !== rowData.fieldCode);
      setSelectedRows(arr);
      setLoader(false);
    }, 1000);
  };

  const {roleData} = useSelector(({role}) => role);
  const disableEdit = roleData?.window?.['Record Format']?.['RF']?.edit;


  const handleCancel = (rowData, key) => {
    const arr = [...selectedRows];
    arr.forEach((ele) => {
      delete ele.deleteState;
    });
    setSelectedRows(arr);
  };
  const columns = [
    {
      title: 'Actions',
    },
    {
      title: 'Position',
    },
    {
      title: 'Field Type',
    },
    {
      title: 'Field Code',
    },
    {
      title: 'Data Type',
    },
    {
      title: 'Description',
    },
    {
      title: 'Field Header',
    },
    {
      title: 'Field Length',
      hidden: values.fixedLength === 'N',
    },
    {
      title: 'Date Format',
    },
  ];
  return (
    <>
      <div className={`mui-custom-table-container global-field-table pt-0`}>
        <DragDropContext onDragEnd={onDragEnd}>
          <table>
            <thead>
              <tr>
                {columns.map(
                  ({title, hidden = false}) => !hidden && <th key={title}>{title}</th>,
                )}
              </tr>
            </thead>
            <Droppable droppableId="droppabe-list">
              {(provided) => (
                <tbody ref={provided.innerRef}>
                  {selectedRows?.length > 0 ? (
                    selectedRows.map((rowData, key) => {
                      return (
                        // deepcode ignore ReactMissingArrayKeys: <please specify a reason of ignoring this>
                        <Draggable draggableId={`draggable-${key}`} index={key} key={key}>
                          {(provided) =>
                            rowData.deleteState ? (
                              <tr
                                className="delete-row"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <td>
                                  <div>
                                    <IconButton
                                      onClick={(e) => {
                                        handleConfirmDelete(rowData, key);
                                      }}
                                    >
                                      <Done />
                                    </IconButton>
                                    <IconButton
                                      onClick={(e) => {
                                        handleCancel(rowData, key);
                                      }}
                                    >
                                      <Clear />
                                    </IconButton>
                                  </div>
                                </td>
                                <td
                                  colSpan={columns.length - 1}
                                  style={{textAlign: 'left', fontWeight: 'bold'}}
                                >
                                  Are you sure you want to delete
                                </td>
                              </tr>
                            ) : (
                              <tr
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <td className="recFormat-center">
                                  <IconButton
                                    disabled={(recordFormatCode && !disableEdit)}
                                    onClick={(e) => {
                                      handleDelete(rowData, key);
                                    }}
                                  >
                                    <DeleteOutlined />
                                  </IconButton>
                                </td>
                                <td>
                                  {rowData.seqNo(
                                    values,
                                    handleChange,
                                    touched,
                                    errors,
                                    inputFieldValues,
                                    setInputFieldValues,
                                    setFieldValue,
                                  )}
                                </td>
                                <td>{rowData.fieldType}</td>
                                <td>{rowData.fieldCode}</td>
                                <td>{rowData.dataType ? rowData.dataType : '-'}</td>
                                <td>
                                  {
                                    <MouseOverPopover
                                      data={rowData.description}
                                      popOverData={rowData.description}
                                      codeLength={rowData?.description?.length}
                                    />
                                  }
                                </td>
                                <td>
                                  {rowData.fieldHeader(
                                    values,
                                    handleChange,
                                    touched,
                                    errors,
                                    inputFieldValues,
                                    setInputFieldValues,
                                    setFieldValue,
                                  )}
                                </td>
                                {values.fixedLength !== 'N' && (
                                  <td>
                                    {rowData.fieldLength(
                                      values,
                                      handleChange,
                                      touched,
                                      errors,
                                      inputFieldValues,
                                      setInputFieldValues,
                                      setFieldValue,
                                    )}
                                  </td>
                                )}
                                <td>
                                  {rowData.format(
                                    values,
                                    handleChange,
                                    touched,
                                    errors,
                                    inputFieldValues,
                                    setInputFieldValues,
                                    setFieldValue,
                                    rowData.dataType,
                                    dropDownData,
                                  )}
                                </td>
                              </tr>
                            )
                          }
                        </Draggable>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={columns.length}>No records to display</td>
                    </tr>
                  )}
                  {provided.placeholder}
                  {loader && <PageLoader />}
                </tbody>
              )}
            </Droppable>
          </table>
        </DragDropContext>
      </div>
    </>
  );
};

export default FieldTable;
